import { useState } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { createSubmission } from "../services/publishFolder";
import { useAuth } from "../../../../context/AuthContext";

/**
 * Custom hook to handle publishing a folder and updating the UI.
 * Manages loading and success states, and invalidates user file structure cache.
 */
export function usePublishFolder() {
  const { currentUser } = useAuth();
  const queryClient = useQueryClient();
  const [isPublishing, setIsPublishing] = useState(false);
  const [publishSuccess, setPublishSuccess] = useState(false);
  const [error, setError] = useState(null);

  const publishFolder = async (folderId) => {
    if (!currentUser || !currentUser.uid) {
      setError(new Error("No current user found for publishing"));
      return;
    }
    setIsPublishing(true);
    setError(null);
    try {
      await createSubmission(currentUser.uid, folderId);
      setPublishSuccess(true);
      // Invalidate the user file structure query to refresh data
      queryClient.invalidateQueries(["userFileStructure"]);
    } catch (err) {
      setError(err);
      setPublishSuccess(false);
    } finally {
      setIsPublishing(false);
    }
  };

  const resetPublishSuccess = () => {
    setPublishSuccess(false);
  };

  return {
    publishFolder,
    isPublishing,
    publishSuccess,
    resetPublishSuccess,
    error,
  };
}
